export const STATIC_ROLES = [
    {
        id: 'regular',
        default: true,
        accessLevel: 3,
        name: 'Team Member',
        info: 'Team Member_info',
        richInfo: 'Team Member_rich_info',
        transferNote: 'Team Member_transfer_note'
    },
    {
        id: 'manager',
        default: true,
        accessLevel: 2,
        name: 'Admin',
        info: 'Admin_info',
        richInfo: 'Admin_rich_info'
    },
    // {
    //     id: 'super admin',
    //     default: true,
    //     accessLevel: 1,
    //     name: 'Super Admin',
    //     info: 'Super Admin_info',
    //     richInfo: 'Super Admin_rich_info',
    //     disabled: true
    // },
    {
        id: 'owner',
        default: true,
        accessLevel: 0,
        name: 'Owner',
        info: 'Owner_info',
        richInfo: 'Owner_rich_info',
        disabled: true
    },
    {
        id: 'client',
        default: true,
        accessLevel: 4,
        name: 'Guest',
        info: 'Guest_info',
        richInfo: 'Guest_rich_info'
    }
];

export const CUSTOM_ROLE_DEFAULT_PERMISSIONS = ['canPlayTour', 'seeUpgradeFeatures'];

export const DEFAULT_PERMISSIONS = {
    editBilling: ['owner'],

    // Access
    viewTeamOverview: ['owner', 'super admin', 'manager'],
    viewAllTasks: ['owner', 'super admin', 'manager', 'regular'],
    viewMemberEmail: ['owner', 'super admin', 'manager', 'regular'],

    // Team
    editTeam: ['owner', 'super admin'],
    inviteToTeam: ['owner', 'super admin', 'manager'],
    removeFromTeam: ['owner', 'super admin'],
    viewTeamClients: ['owner', 'super admin'],
    viewTeamSettings: ['owner', 'super admin', 'manager', 'regular'],
    leaveTeam: ['manager', 'regular', 'client'],

    // User
    editUser: ['owner', 'super admin', 'manager'],
    editRole: ['owner', 'super admin', 'manager'],
    viewUserActivity: ['owner', 'super admin', 'manager', 'regular'],
    viewUserLabels: ['owner', 'super admin', 'manager', 'regular'],
    viewClientUserLabels: ['client'],

    // Subteam
    createSubteam: ['owner', 'super admin', 'manager'],
    editSubteam: ['owner', 'super admin', 'manager'],
    viewSubteam: ['owner', 'super admin', 'manager', 'regular'],
    removeSubteam: ['owner', 'super admin', 'manager'],

    // Project
    createProject: ['owner', 'super admin', 'manager', 'regular'],
    editProject: ['owner', 'super admin', 'manager', 'custom'], // own projects
    removeProject: ['owner', 'super admin', 'manager', 'custom'], // own projects
    inviteToProject: ['owner', 'super admin', 'manager', 'custom'], // own projects
    leaveProject: ['super admin', 'manager', 'regular'],
    removeFromProject: ['owner', 'super admin', 'manager', 'custom'], // own projects
    viewProjectClients: ['owner', 'super admin', 'manager', 'custom'], // own projects
    viewProjectSettings: ['owner', 'super admin', 'manager', 'regular', 'custom'], // own projects
    createProjectTemplate: ['owner', 'super admin', 'manager', 'regular'],
    projectAutomations: ['owner', 'super admin', 'manager', 'custom'], // own projects

    // Labels
    createLabel: ['owner', 'super admin', 'manager', 'regular'],
    editLabel: ['owner', 'super admin', 'manager', 'custom'], // own labels
    removeLabel: ['owner', 'super admin', 'manager', 'custom'], // own labels

    // Milestone
    createMilestone: ['owner', 'super admin', 'manager', 'regular'],
    editMilestone: ['owner', 'super admin', 'manager', 'regular'],
    removeMilestone: ['owner', 'super admin', 'manager', 'regular'],
    publicShareMilestones: ['owner', 'super admin', 'manager', 'regular'],

    // Task group
    createTaskGroup: ['owner', 'super admin', 'manager', 'regular'],
    editTaskGroup: ['owner', 'super admin', 'manager', 'regular'],
    removeTaskGroup: ['owner', 'super admin', 'manager', 'regular'],

    // Task
    createTask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editTask: ['owner', 'super admin', 'manager', 'regular', 'client', 'custom'], // own task
    moveTask: ['owner', 'super admin', 'manager', 'regular', 'client', 'custom'],
    completeTask: ['owner', 'super admin', 'manager', 'regular', 'client', 'custom'], // own task
    hideTask: ['owner', 'super admin', 'manager', 'regular'],
    removeTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // own task
    assignToTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // own task
    unassignFromTask: ['owner', 'super admin', 'manager', 'regular', 'custom'], // own task
    publicShareTasks: ['owner', 'super admin', 'manager', 'regular'],

    // Subtask
    createSubtask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editSubtask: ['owner', 'super admin', 'manager', 'regular', 'client'],
    completeSubtask: ['owner', 'super admin', 'manager', 'regular', 'client', 'custom'],
    removeSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    assignToSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    unassignFromSubtask: ['owner', 'super admin', 'manager', 'regular', 'custom'],

    // Folder
    createFolder: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editFolder: ['owner', 'super admin', 'manager', 'custom'],
    removeFolder: ['owner', 'super admin', 'manager', 'custom'], // own folders

    // File
    addFile: ['owner', 'super admin', 'manager', 'regular', 'client'],
    editFile: ['owner', 'super admin', 'manager', 'custom'],
    removeFile: ['owner', 'super admin', 'manager', 'custom'], // own files

    // Doc
    createDoc: ['owner', 'super admin', 'manager', 'regular', 'client'],

    // Chat
    fullChat: ['owner', 'super admin', 'manager', 'regular'],
    pinMessage: ['owner', 'super admin', 'manager', 'regular'],

    ownerChat: ['client'],
    guestChat: ['owner'],

    // Time Tracking
    viewTimeReports: ['owner', 'super admin', 'manager', 'custom'], // own reports
    startStopTimer: ['owner', 'super admin', 'manager', 'regular', 'custom'],
    editTimer: ['owner', 'super admin', 'manager', 'custom'], // own reports
    removeTimer: ['owner', 'super admin', 'manager', 'custom'], // own reports
    addManualTime: ['custom'], // own time

    // Custom Fields
    createCustomFields: ['owner', 'super admin', 'manager', 'regular'],
    editCustomFields: ['owner', 'super admin', 'manager', 'regular'],
    removeCustomFields: ['owner', 'super admin', 'manager', 'regular'],

    // Common
    canPlayTour: ['owner', 'super admin', 'manager', 'regular'],
    seeUpgradeFeatures: ['owner', 'super admin', 'manager', 'regular'],

    // Forms
    createForm: ['owner', 'super admin', 'manager', 'regular'],
    editForm: ['owner', 'super admin', 'manager', 'custom'], // own forms
    removeForm: ['owner', 'super admin', 'manager', 'custom'], // own forms

    // Templates
    createTemplate: ['owner', 'super admin', 'manager', 'regular'],
    viewTemplate: ['owner', 'super admin', 'manager', 'regular'],
    editTemplate: ['owner', 'super admin', 'manager', 'custom'], // own templates
    removeTemplate: ['owner', 'super admin', 'manager', 'custom'], // own templates
};
